export const FINANCE_EXPORT_REPORTS = ['financeExportReports'] as const;
